/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { forwardRef } from "react";

import styled from "styled-components";

import { useCurrentUser } from "src/app/useCurrentUser";
import { Avatar } from "src/components/Shared/User/Avatar";

interface Props {
  handleClick: () => void;
  styles?: React.CSSProperties;
}

export const CurrentUserAvatar = forwardRef<any, Props>(({ handleClick, styles }, ref) => {
  const currentUser = useCurrentUser()!;
  const unreadNotificationCount = currentUser.observe((state) => state.unreadNotificationCount);
  return (
    <AvatarAreaWrapper id="cy-avatar-dropdown" style={styles}>
      {unreadNotificationCount > 0 && <UnreadDot />}
      <AvatarWrapper onClick={() => handleClick()} ref={ref} onDoubleClick={(e) => e.stopPropagation()}>
        <Avatar src={currentUser.avatarURL(30)} size={30} />
      </AvatarWrapper>
    </AvatarAreaWrapper>
  );
});

const AvatarAreaWrapper = styled.div`
  position: relative;
`;

const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;
  /* fade in 2px black boarder on hover */
  &:hover {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.text.subtle};
  }
  transition: all 150ms ease;
`;

const UnreadDot = styled.div`
  background-color: #ad5555;
  color: white;
  width: 8px;
  height: 8px;
  border-radius: 100px;
  position: absolute;
  top: 0px;
  right: 0px;
`;
